import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=56ef2d5d&scoped=true"
import script from "./CategoryModal.vue?vue&type=script&lang=js"
export * from "./CategoryModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=56ef2d5d&prod&scoped=true&lang=css"
import style1 from "./CategoryModal.vue?vue&type=style&index=1&id=56ef2d5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef2d5d",
  null
  
)

export default component.exports